<span *ngIf="id !== null && (getEnumValById(id, enum) | async); let val else noData">
  <span *ngIf="val">{{val.name}}</span>
</span>
<ng-template #noData>
  <span *ngIf="noDataTemplate">
    <i class="fas fa-minus noData"></i>
  </span>
</ng-template>
